import { render } from "./Employee.vue?vue&type=template&id=7044e35a&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=7044e35a&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7044e35a"]])

export default __exports__